// extracted by mini-css-extract-plugin
module.exports = {"expand":"Footer--expand--KEx0t","controls":"Footer--controls--221Au"};